import { useSelector } from "react-redux";
import { useRef, useState, useEffect } from "react";
import functionSelectorIamge from "../../../assets/smarthome/installationSection/functionSelector.png";
import SWITCH_1 from "../../../assets/products/SWITCH_1.png";
import COMMAND_1 from "../../../assets/products/COMMAND_1.png";
import textContentSmarthomeProductSection from "../ui/textContent-smarthome-ProductSection";

export default function InstallationSection(props) {
  const { textContent, language } = { ...props };
  const isMobile = useSelector((state) => state.screen.isMobile);
  const screenWidth = useSelector((state) => state.screen.screenWidth);

  const deviceCard = (image, productURL, feature1, feature2, feature3) => {
    return (
      <div className="multifonctionProduct " href={productURL}>
        <img
          src={image}
          aria-hidden="true"
          // className="automation-item-icon"
        />
        <div className="multifunctionProduct-features">
          <h4
            className={`multifunctionProduct-feature  ${isMobile ? "mobile" : ""}`}
          >
            {feature1}
          </h4>
          <h4
            className={`multifunctionProduct-feature  ${isMobile ? "mobile" : ""}`}
          >
            {feature2}
          </h4>
          <h4
            className={`multifunctionProduct-feature  ${isMobile ? "mobile" : ""}`}
          >
            {feature3}
          </h4>
        </div>
      </div>
    );
  };

  return (
    <section className="container">
      <div className="container-small">
        <h1 className="title-gradient">
          {textContent.installationSection.title[language]}
        </h1>
        <h2>{textContent.installationSection.subtitle[language]}</h2>
        <p className={`installation-description ${isMobile ? "mobile" : ""}`}>
          {textContent.installationSection.description[language]}
        </p>
        {isMobile ? (
          <div className="container-empty-extra-small" />
        ) : (
          <div className="container-empty-small" />
        )}
        <div className="installation-visuals">
          <div className="multiDin-function-image">
            <img src={functionSelectorIamge} />
          </div>
          <div className="installation-cards">
            {deviceCard(
              SWITCH_1,
              textContentSmarthomeProductSection.productSection.items.products
                .productsList.SWITCH_1.link,
              textContentSmarthomeProductSection.productSection.items.products
                .productsList.SWITCH_1.features.radiator[language],
              textContentSmarthomeProductSection.productSection.items.products
                .productsList.SWITCH_1.features.acccessControl[language],
              textContentSmarthomeProductSection.productSection.items.products
                .productsList.SWITCH_1.features.shutters[language],
            )}
            {deviceCard(
              COMMAND_1,
              textContentSmarthomeProductSection.productSection.items.products
                .productsList.COMMAND_1.link,
              textContentSmarthomeProductSection.productSection.items.products
                .productsList.COMMAND_1.features.switch[language],
              textContentSmarthomeProductSection.productSection.items.products
                .productsList.COMMAND_1.features.bp[language],
              textContentSmarthomeProductSection.productSection.items.products
                .productsList.COMMAND_1.features.threePosition[language],
            )}
          </div>
        </div>
      </div>
      {isMobile ? (
        <div className="container-empty-small" />
      ) : (
        <div className="container-empty-small" />
      )}
    </section>
  );
}
